import { Box, Typography } from '@mui/joy';
import { PencilSimpleLine, TrashSimple } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Confirmation } from 'core/components';
import { UomConversionForm } from 'corporate/components/CorporatePartUom/UomConversionForm';
import { useRemoveUomConversions } from 'parts/hooks';
import { IUomConversion } from 'parts/types';
import { Color, Level } from 'theme/enums';

interface IProps {
  data: IUomConversion;
}

export const Actions = (props: IProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);

  const { part, manufacturerId, ...uomConversion } = props.data;

  const { t } = useTranslation();
  const { removeUomConversions } = useRemoveUomConversions();

  const handleRemove = async () => {
    removeUomConversions([uomConversion.id]);
    setIsRemoving(false);
  };

  return (
    <>
      <Box sx={{ display: 'flex', gap: '8px' }}>
        <Typography
          color={Color.PRIMARY}
          level={Level.BODY_SM}
          onClick={() => setIsEditing(true)}
          sx={{ cursor: 'pointer' }}
        >
          <PencilSimpleLine />
        </Typography>

        <Typography
          color={Color.DANGER}
          level={Level.BODY_SM}
          onClick={() => setIsRemoving(true)}
          sx={{ cursor: 'pointer' }}
        >
          <TrashSimple />
        </Typography>
      </Box>
      <UomConversionForm
        corporatePart={{ part, manufacturerId }}
        uomConversion={uomConversion}
        isOpen={isEditing}
        onClose={() => setIsEditing(false)}
      />
      <Confirmation
        isOpen={isRemoving}
        title={t('titleRemoveUomConversion')}
        message={t('messageConfirmRemoveUomConversion')}
        confirmBtnColor={Color.DANGER}
        onConfirm={handleRemove}
        onCancel={() => setIsRemoving(false)}
      />
    </>
  );
};
